import type { ReactNode } from 'react';

import { Input } from '@/components/ui/input';

/**
 * A settings list's toolbar (spec 129 FR-001): a filter by name and the count,
 * the shape the Secrets page already had, so every list reads the same.
 */
export function ListToolbar({
  label,
  placeholder = 'Filter by name',
  query,
  onQueryChange,
  shown,
  total,
  noun,
  children,
}: {
  /** The filter field's accessible name: "Filter connections". */
  label: string;
  placeholder?: string;
  query: string;
  onQueryChange: (next: string) => void;
  shown: number;
  total: number;
  /** Singular and plural: ["connection", "connections"]. */
  noun: readonly [string, string];
  /** Anything else the toolbar carries, between the filter and the count. */
  children?: ReactNode;
}) {
  const word = (n: number) => (n === 1 ? noun[0] : noun[1]);
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Input
        aria-label={label}
        placeholder={placeholder}
        value={query}
        onChange={(event) => {
          onQueryChange(event.target.value);
        }}
        className="h-8 w-full max-w-xs text-sm max-md:max-w-none"
      />
      {children}
      <p className="text-muted-foreground ms-auto text-xs tabular-nums">
        {shown === total
          ? `${String(total)} ${word(total)}`
          : `Showing ${String(shown)} of ${String(total)} ${word(total)}`}
      </p>
    </div>
  );
}
